export default __webpack_public_path__ + "static/media/Main_Top_Pic.d5ad9b99.png";